import script from "./BFilterEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./BFilterEditor.vue?vue&type=script&lang=ts&setup=true"

import "./BFilterEditor.vue?vue&type=style&index=0&id=43678140&lang=scss"

const __exports__ = script;

export default __exports__